function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Modifier from 'ember-modifier';
import { TextField } from 'field-kit';
import USDateFormatter from '@banking/ui/utils/field-kit-formatters/us-date-formatter';
export default class FormatDate extends Modifier {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handler", void 0);
    _defineProperty(this, "fieldKit", void 0);
  }
  get callback() {
    return this.args.positional[0];
  }
  didInstall() {
    if (this.element.tagName.toUpperCase() !== 'MARKET-INPUT-TEXT') {
      throw new Error('The format-date modifier can only be applied to a market input text element.');
    }
    const element = this.element;
    this.handler = event => {
      // We can safely assume this event type since we know for certain the
      // element is a market-input-text.
      this.install(event, element);
    };
    element.addEventListener('marketInputDidLoad', this.handler);
  }
  willRemove() {
    const element = this.element;
    if (this.handler) {
      element.removeEventListener('marketInputDidLoad', this.handler);
      delete this.handler;
    }
    if (this.fieldKit) {
      this.fieldKit.destroy();
      delete this.fieldKit;
    }
  }
  install(event, element) {
    const input = event.detail.input;
    const formatter = new USDateFormatter();
    if (this.args.named.value) {
      element.value = formatter.format(this.args.named.value);
    }
    this.fieldKit = new TextField(input, formatter);
    const textDidChange = field => {
      const value = field.value();
      this.callback(value);
    };
    this.fieldKit.setDelegate({
      textDidChange
    });
  }
}